/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Project.Entrypoint
 * OpenAPI spec version: 1.0.0
 */

export type UserCompany = typeof userCompany[keyof typeof userCompany];

export const userCompany = {
  Predictis: 'predictis',
  CapFinances: 'capFinances',
} as const;
